/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const buildCompanies = (data: any) =>
  data &&
  data.map((obj: any) => ({
    id: obj.company_id,
    name: obj.visible_name,
  }));
